export default "__VITE_ASSET__W4l9V3Rb__"